module.exports = __webpack_public_path__ + "static/media/Нормуродов Х.Н., Хасанов А.Б., Худаеров У.О..56a5eb5f.pdf";